import { isAxiosError } from 'axios';

const genericError = `lcp.errors.error_occurred`;
const errorMap: Record<string | number, string> = {
  400: `lcp.errors.bad_request`,
  401: `lcp.errors.authorization_error`,
  404: `lcp.errors.not_found`,
  409: `lcp.errors.conflict_error`,
  500: `lcp.errors.internal_server_error`,

  genericError,
};

export const createErrorParser =
  (t: (key: string) => string, customMap: Partial<typeof errorMap> = {}) =>
  (error: unknown) => {
    if (!error) {
      return undefined;
    }

    const map = { ...errorMap, ...customMap };
    if (isAxiosError(error)) {
      const { status } = error;
      if (status) {
        const errorKey: string = (map[status] ?? genericError) as string;
        return t(errorKey);
      }
    }

    return t(genericError);
  };
